/**
 * @generated SignedSource<<a757cd2680738f94b3c094005be65b94>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopicSelector_orgTopic$data = ReadonlyArray<{
  readonly id: string;
  readonly isPrivate: boolean;
  readonly name: string;
  readonly " $fragmentType": "TopicSelector_orgTopic";
}>;
export type TopicSelector_orgTopic$key = ReadonlyArray<{
  readonly " $data"?: TopicSelector_orgTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopicSelector_orgTopic">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TopicSelector_orgTopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    }
  ],
  "type": "OrgTopic",
  "abstractKey": null
};

(node as any).hash = "982aa1f0d3b053a7be6cad4dc23c3b12";

export default node;
